export const CASES = {
    UPDATE_DEAL_DRO_CHANGES: 'UPDATE_DEAL_DRO_CHANGES',
    UPDATE_DEAL_DRO_CHANGES_SEARCH_FORM: 'UPDATE_DEAL_DRO_CHANGES_SEARCH_FORM',
    CLEAR_DEAL_DRO_CHANGES: 'CLEAR_DEAL_DRO_CHANGES',
};
